import { ApiTableFilter } from '../../../shared/models/table-filter.model';

export type QRTemplateType = 'custom' | 'system' | string;

export interface QRTemplate {
  uuid: string;
  name: string;
  description: string;
  type: QRTemplateType;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface QRTemplatesListMeta {
  currentPage: number;
  perPage: number;
  total: number;
  totalPages: number;
}

export interface QRTemplatesListResponse {
  data: QRTemplate[];
  meta: QRTemplatesListMeta;
}

export interface QRTemplatesListParams {
  page?: number;
  per_page?: number;
  search?: string;
  sort?: string;
  sort_direction?: string;
  filters?: ApiTableFilter[];
  filter_link?: string;
}

export const DEFAULT_QR_TEMPLATES_CURRENT_PAGE = 1;
export const DEFAULT_QR_TEMPLATES_PER_PAGE = 25;
export const QR_TEMPLATES_PAGE_SIZE_OPTIONS = [DEFAULT_QR_TEMPLATES_PER_PAGE, 50, 100] as const;
